const LinkOff = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.783 4.782a.5.5 0 0 0-.708.708l3.01 3.01H7a3.5 3.5 0 1 0 0 7h3.5a.5.5 0 0 0 0-1H7a2.5 2.5 0 0 1 0-5h2.086l2 2H10a.5.5 0 0 0 0 1h2.086l2 2H13.5a.5.5 0 0 0 0 1h1.586l3.424 3.425a.5.5 0 1 0 .707-.707L10.5 9.5zM20.5 12a3.5 3.5 0 0 1-2.682 3.404l-.904-.904H17a2.5 2.5 0 0 0 0-5h-3.5a.5.5 0 0 1 0-1H17a3.5 3.5 0 0 1 3.5 3.5"
      clipRule="evenodd"
    />
  </>
)
export default LinkOff
